import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomeView.vue'),
    meta: { title: '家庭食谱' }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: { title: '登录', guestOnly: true }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/views/AdminView.vue'),
    meta: { title: '管理员', requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/history',
    name: 'History',
    component: () => import('@/views/HistoryView.vue'),
    meta: { title: '历史记录', requiresAuth: true }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['auth/isLoggedIn']
  const isAdmin = store.getters['auth/isAdmin']
  const guestMode = localStorage.getItem('ff_guest_mode') === '1'

  // 已登录用户不能访问 /login
  if (to.meta.guestOnly && isLoggedIn) {
    return next('/')
  }

  // 未登录且未开启访客模式，访问首页时重定向到登录页
  if (to.path === '/' && !isLoggedIn && !guestMode) {
    return next({ name: 'Login' })
  }

  // 需要登录的页面
  if (to.meta.requiresAuth && !isLoggedIn) {
    return next({ name: 'Login', query: { redirect: to.fullPath } })
  }

  // 需要 admin 权限的页面
  if (to.meta.requiresAdmin && !isAdmin) {
    store.dispatch('showToast', '权限不足，需要管理员账号')
    return next('/')
  }

  next()
})

router.afterEach((to) => {
  document.title = `${to.meta.title || 'Family Feast'} - Family Feast`
})

export default router
